import { ReportingConfig } from '@opengov/app-config-reporting';
import { Entity } from '@opengov/bnp-core';
import { initializeGrafanaFaro, isClientInitialized } from './grafanaFaroUtil';
import { faro, type Faro } from '@grafana/faro-web-sdk';
import { useEffect } from 'react';
import { ISessionV3 } from '@opengov/app-core/types';

const REPORTING_APP_COLLECTOR_URL = ReportingConfig.FARO_COLLECTOR_URL;

type InitConfig = {
  session?: ISessionV3;
  entity?: Entity;
};

function initialize({ session, entity }: InitConfig) {
  return initializeGrafanaFaro({
    appName: 'reporting-app',
    collectorUrl: REPORTING_APP_COLLECTOR_URL,
    session,
    entity
  });
}

function getFaro(): Faro {
  if (!isClientInitialized(faro)) {
    throw new Error('Faro is not initialized');
  }
  return faro;
}

function isInitialized(): boolean {
  return isClientInitialized(faro);
}

export function useInitializeFaro({ session, entity }: Partial<InitConfig>) {
  useEffect(() => {
    if (
      process.env.NODE_ENV !== 'development' &&
      !ReportingConfig.IS_PSP_BUILD &&
      !isClientInitialized(faro) &&
      session &&
      entity
    ) {
      GrafanaFaro.initialize({ session, entity });
    }
  }, [session, entity]);
}

export const GrafanaFaro = {
  initialize,
  isInitialized,
  getFaro
};
